/* eslint-disable react/button-has-type */
import React from 'react';
import SyncLoader from 'react-spinners/ClipLoader';
import cx from 'classnames';
import styles from './LoadingButton.module.scss';

interface LoadingButtonI {
  disabled?: boolean;
  block?: boolean;
  loading?: boolean;
  text: string;
  type: 'button' | 'submit' | 'reset';
  className?: string;
  variant?: 'primary' | 'secondary' | 'tertiary' | 'quaternary' | 'reddelete';
  onClick?: CallableFunction;
}

const LoadingButton = (props: LoadingButtonI): JSX.Element => {
  const { disabled, loading, text, type, className, onClick, block, variant = 'primary' } = props;

  return (
    <button
      className={cx(styles.root, className, {
        [styles.block]: block,
        [styles.primary]: variant === 'primary',
        [styles.reddelete]: variant === 'reddelete',
      })}
      type={type}
      disabled={disabled}
      onClick={(): void => {
        if (onClick) {
          onClick();
        }
      }}
    >
      {loading ? <SyncLoader size={20} color="#ffffff" loading={loading} /> : text}
    </button>
  );
};

export default LoadingButton;
